<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>IMPORT_DISCOUNTS</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6 text-md-right">
          <label for="file-upload" translate>SELECT_FILES</label>
        </div>
        <div class="col-md-6">
          <input
            #inputFile
            type="file"
            class="_custom-file-input"
            id="file-upload"
            aria-describedby="file-upload"
            [multiple]="false"
            [disabled]="loading ? true : null"
            (change)="onFileSelect($event)"
          />
          <!--  -->
        </div>
      </div>
      <div *ngIf="response" class="mt-3">
        <div translate>{{response.message}}</div>
        <div><span translate>STEP</span>:&nbsp;<span translate>{{response.step}}</span></div>
      </div>
      <div *ngIf="loading" class="text-center mt-3">
        <i class="fa fa-spinner fa-spin fa-lg"></i>
      </div>
</div>

<div class="modal-footer">
  <div class="btn-group btn-group-justified w-100">
    
    <button class="btn btn-primary" (click)="cancel()" translate>OK</button>
  </div>
</div>
